import { render } from "./BannersTab.vue?vue&type=template&id=5e14d3c8"
import script from "./BannersTab.vue?vue&type=script&lang=js"
export * from "./BannersTab.vue?vue&type=script&lang=js"

import "./BannersTab.vue?vue&type=style&index=0&id=5e14d3c8&lang=scss"

import exportComponent from "/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__